import { domainUrl } from '../constants';

export const API_CUSTOMER_TOP_ORDERS = `${domainUrl}auth/customers/top-orders`;
export const API_TOP_PRODUCT_REVIEWS = `${domainUrl}products/top-reviews`;
export const API_TOP_PRODUCT_COMMENTS = `${domainUrl}products/top-comments`;
export const API_TOP_PRODUCT_WISHLIST = `${domainUrl}products/top-wishlists`;
export const API_TOP_PRODUCT_ORDERS = `${domainUrl}products/top-orders`;
export const API_ORDERS_STATISTICS = `${domainUrl}orders/stats`;
export const API_TOP_COUPONS_USED = `${domainUrl}coupons/top-used`;
